import { RESOURCE } from '@src/constants';
import api from './api';

const createInstantVoiceTraining = async ({
  audioLink,
  denoise,
  audioId,
  sentenceId,
}) => {
  const response = await api({
    method: 'POST',
    url: `${RESOURCE.VOICE_CLONING}${RESOURCE.VOICES}/instant-voice-training`,
    data: {
      audioLink,
      denoise,
      audioId,
      sentenceId,
    },
  });
  return response;
};

const getInstantVoiceTrainingDemo = async () => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.VOICE_CLONING}/sentences/demo`,
  });
  return response;
};

const qualityAudioVoiceInstantTraining = async ({ audioId, audioLink }) => {
  const response = await api({
    method: 'GET',
    url: `${RESOURCE.VOICE_CLONING}/audios/quality`,
    params: { audioId, audioLink },
  });
  return response;
};

export {
  createInstantVoiceTraining,
  getInstantVoiceTrainingDemo,
  qualityAudioVoiceInstantTraining,
};
